import React from "react";

const Input = (props) => {
  return (
    <input
      className="w-full px-4 py-2 border border-gray-300 rounded-sm rounded outline-lime-600 outline-offset-2 disabled:bg-transparent disabled:border-none disabled:px-0 disabled:py-1 disabled:text-gray-400 "
      {...props}
    />
  );
};

export default Input;
